<template>
  <div class="service detail wrap">
    <!-- 배경 흐르는 텍스트 -->
    <div class="text-bg cloud">
      <div class="text-wrap">
        <p>{{ $t('service.detail.cloud.lineText.01') }}</p>
        <p>{{ $t('service.detail.cloud.lineText.02') }}</p>
        <p>{{ $t('service.detail.cloud.lineText.03') }}</p>
      </div>
    </div>

    <!-- 타이틀 섹션 -->
    <HalfPageLayout class="cloud title">
      <template #half-left>
        <div class="img cloud"></div>
      </template>
      <template #half-right>
        <div class="inner-contents">
          <div class="contents-title">
            <h3 style="line-height: 1.1">
              {{ $t('service.title.cloud') }}
            </h3>
            <h6>Cloud Consulting &amp; Managed Service</h6>
            <h4>{{ $t('service.detail.cloud.subTitle') }}</h4>
          </div>
          <h5>{{ $t('service.detail.cloud.desc') }}</h5>
        </div>
      </template>
    </HalfPageLayout>

    <!-- 클라우드 컨설팅 -->
    <HalfPageLayout class="cloud summary bg-light">
      <template #half-left>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('service.detail.cloud.firstPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:magnifying-glass-thin" />
              <dl>
                <dt>{{ $t('service.detail.cloud.firstPage.contents.01.title') }}</dt>
                <dd>{{ $t('service.detail.cloud.firstPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:chart-line-up-thin" />
              <dl>
                <dt>{{ $t('service.detail.cloud.firstPage.contents.02.title') }}</dt>
                <dd>{{ $t('service.detail.cloud.firstPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:shield-check-thin" />
              <dl>
                <dt>{{ $t('service.detail.cloud.firstPage.contents.03.title') }}</dt>
                <dd>{{ $t('service.detail.cloud.firstPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #half-right>
        <div class="img visual-01"></div>
      </template>
    </HalfPageLayout>

    <!-- 클라우드 구축 및 마이그레이션 -->
    <HalfPageLayout class="cloud summary">
      <template #half-left>
        <div class="img visual-02"></div>
      </template>
      <template #half-right>
        <div class="animation-bg">
          <div class="gear"><SvgGear /></div>
          <div class="gear"><SvgGear /></div>
        </div>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('service.detail.cloud.secondPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:steps-thin" />
              <dl>
                <dt>{{ $t('service.detail.cloud.secondPage.contents.01.title') }}</dt>
                <dd>{{ $t('service.detail.cloud.secondPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:cloud-arrow-up-thin" />
              <dl>
                <dt>{{ $t('service.detail.cloud.secondPage.contents.02.title') }}</dt>
                <dd>{{ $t('service.detail.cloud.secondPage.contents.02.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
    </HalfPageLayout>

    <!-- 클라우드 운영 (Managed Service) -->
    <HalfPageLayout class="cloud summary bg-light">
      <template #half-left>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('service.detail.cloud.thirdPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:monitor-thin" />
              <dl>
                <dt>{{ $t('service.detail.cloud.thirdPage.contents.01.title') }}</dt>
                <dd>{{ $t('service.detail.cloud.thirdPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:gauge-thin" />
              <dl>
                <dt>{{ $t('service.detail.cloud.thirdPage.contents.02.title') }}</dt>
                <dd>{{ $t('service.detail.cloud.thirdPage.contents.02.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #half-right>
        <div class="img visual-03"></div>
      </template>
    </HalfPageLayout>

    <!-- 도입 기대 효과 -->
    <section class="section cloud benefit bg-light">
      <h2 class="hl section-title" data-aos="fade">
        {{ $t('service.detail.cloud.benefit.title') }}
      </h2>
      <div class="section-contents">
        <div
          class="benefit-grid inner-contents"
          data-aos="fade"
          data-aos-delay="200"
        >
          <dl
            v-for="(item, key) in $tm('service.detail.cloud.benefit.contents')"
            :key="key"
            class="benefit-card"
          >
            <dt>{{ item.title }}</dt>
            <dd>{{ item.desc }}</dd>
          </dl>
        </div>
        <router-link to="/contact" class="button big line">
          {{ $t('service.detail.contact') }}
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import HalfPageLayout from '@/components/HalfPageLayout'
import { Icon } from '@iconify/vue'
import SvgGear from '@/components/SvgGear'

export default {
  name: 'ServiceDetailCloudConsulting',
  components: { HalfPageLayout, Icon, SvgGear }
}
</script>

<style scoped>
</style>
